/**
 * @file Accept-Language 注入工具
 *
 * 用法：
 *   import { setAcceptLanguageHeader } from 'src/utils/locale-header';
 *
 *   axios.interceptors.request.use(config => setAcceptLanguageHeader(config));
 *
 *   // 或在自定义 gateway 封装的 headers 中：
 *   headers: { 'Accept-Language': getCurrentLocale() }
 *
 * 设计原则（详见 PLAN.md 阶段 3）：
 *   - 取值统一使用 locale-reader 的 getCurrentLocale()
 *   - 不覆盖业务调用方显式传入的 Accept-Language（大小写均检测）
 *   - 不接管 CDN / 静态资源 / 第三方 SDK / 埋点
 */

import { getCurrentLocale } from 'src/utils/locale-reader';

/**
 * 注入 Accept-Language header（不覆盖显式值）
 * @param {object} config axios request config
 * @returns {object} 同一 config（原地修改）
 */
export function setAcceptLanguageHeader(config) {
    if (!config) return config;
    config.headers = config.headers || {};
    const hasExplicit = Object.keys(config.headers).some(
        key => key.toLowerCase() === 'accept-language'
    );
    if (!hasExplicit) {
        config.headers['Accept-Language'] = getCurrentLocale();
    }
    return config;
}

export { getCurrentLocale };
